import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Input from './Input'

import styles from './TextInput.module.scss'

const propTypes = {
  className: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
}

const StyledInput = React.forwardRef((props, ref) => (
  <Input className={styles.input} ref={ref} {...props} />
))

const TextInput = React.forwardRef(
  ({ className, input, onFocus, onBlur, ...restProps }, ref) => {
    const [focused, setFocused] = useState(false)
    const MyInput = input || StyledInput

    return (
      <div
        className={classnames(
          styles.root,
          focused && styles.focused,
          className
        )}
      >
        <MyInput
          onFocus={e => {
            setFocused(true)
            if (onFocus) onFocus(e)
          }}
          onBlur={e => {
            setFocused(false)
            if (onBlur) onBlur(e)
          }}
          ref={ref}
          {...restProps}
        />
      </div>
    )
  }
)

TextInput.propTypes = propTypes
TextInput.displayName = 'TextInput'

export default TextInput
